module.exports = __webpack_public_path__ + "static/img/Cale_Hooker_desktop.5f4ce4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cale_Hooker_desktop.jpg
// module id = i6xS
// module chunks = 0